import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { authSlice } from "./auth";
import { API } from "./api";
import "./admin/settings/auditLogSlice";
import "./admin/bankTransferSlice";
import "./investor/investorAuthApi";
import "./investor/investorKycApi";
import "./investor/investorInvestmentsApi";
import "./investor/investorMarketplaceApi";
import "./investor/investorRealEstateApi";
import "./activity/activityApi";
import "./admin/investorKyc/staffInvestorKycApi";
import "./admin/investorPortal/staffInvestmentsApi";
import "./admin/investorPortal/staffWebsiteTestimonialsApi";
import "./admin/marketplace/staffMarketplaceApi";
import "./admin/investorOperations/staffRealEstateApi";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    [API.reducerPath]: API.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(API.middleware),
});

setupListeners(store.dispatch);
